if (!customElements.get('rb-gift-details')) {
  customElements.define('rb-gift-details', class extends HTMLElement {
    connectedCallback() {
      if (this.trigger) return;
      this.trigger = this.querySelector('.rb-gift-trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;
      this.trigger.addEventListener('click', event => {
        this.openedWithPointer = event.detail > 0;
        document.body.append(this.dialog);
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.dialog.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        if (this.isConnected) {
          if (this.openedWithPointer) this.trigger.blur();
          else this.trigger.focus({preventScroll:true});
        }
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.dialog?.remove();
    }
  });
}
